import type { VehicleId } from '../../types/gcs/vehicle';
import type { GcsData } from '../../types/gcs/gcsData';

/**
 * Selector to get the takeoff prohibition reason for a vehicle's active mission, if any.
 *
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns The takeoff prohibition string if non-null, otherwise null/undefined
 */
export function selectVehicleTakeoffProhibition(
  data: Map<string, GcsData>,
  gcsId: string,
  vehicleId: VehicleId
): string | null | undefined {
  const gcsData = data.get(gcsId);
  if (!gcsData) return undefined;

  const missionId = gcsData.liveMissionsMap.get(vehicleId)?.missionId;
  if (!missionId) return undefined;

  return gcsData.missionPreflightStateMap.get(missionId)?.takeoffProhibition;
}
